import axios from 'axios'
import configServer from '../../configs/server'
import { getAccessToken } from "../AuthServices"

const makeApiRequest = () => {
    const accessToken = getAccessToken()

    const api = axios.create({
        baseURL: configServer.barcodeUrl,
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });


    api.interceptors.response.use(
        response => response,
        error => {
            const { response } = error

            if (response && typeof response === 'object') {
                const { status, data } = response
                if (data && typeof data === 'object') {
                    return Promise.reject({
                        ...data,
                        status: status,
                        message: data.message || error.message
                    })
                }
            }
            return Promise.reject(error)
        }
    )

    return api
}

export default makeApiRequest
